import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cf02a28"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hd-mod-stopwatch__line-1" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hd-mod-stopwatch__line-2" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hd-mod-stopwatch__clock" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isActive)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
				'hd-mod-stopwatch',
				_ctx.activeFrame
			])
        }, [
          _createVNode(_component_lyra_asset, {
            class: "hd-mod-stopwatch__label",
            "asset-key": `mod-timer-${_ctx.activeFrame}`
          }, null, 8, ["asset-key"]),
          _hoisted_1,
          _hoisted_2,
          _hoisted_3
        ], 2))
      : _createCommentVNode("", true)
  ]))
}